import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminAddBuildingsApi } from "../../../../apiservice/admin-General-ApiService";
import { sampleApiCall } from "../../../../apiservice/authService";
import useFormatApiRequest from "../../../../hooks/formatApiRequest";
import { getFormData } from "../../../../utils/basic.utils";
import "./admin-builiding-add.css";

export const AdminAddBuilding: React.FC<{}> = () => {
  const [loadApi, setLoadApi] = useState(false);
  const [payLoad, setpayLoad] = useState<any>({});
  const [payLoadFormData, setpayLoadFormData] = useState<FormData>(
    getFormData({})
  );
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [imagePreview, setImagePreview] = useState<string>("");

  const navigate = useNavigate();

  // Show a preview of the selected image
  useEffect(() => {
    if (!payLoad?.image) {
      setImagePreview("");
      return;
    }
    const previewUrl = URL.createObjectURL(payLoad.image);
    setImagePreview(previewUrl);
    return () => URL.revokeObjectURL(previewUrl);
  }, [payLoad?.image]);

  // Use to collect Input change Change
  const handleInputChange = (event: any) => {
    const name = event.target.name;
    const value = name === "image" ? event.target.files[0] : event.target.value;
    setpayLoad((values: any) => ({ ...values, [name]: value }));
  };

  // Use to Submit Form
  const handleSubmit = (event: any) => {
    event.preventDefault();
    setpayLoadFormData(
      getFormData({
        ...payLoad,
      })
    );
    setLoadApi(true);
    setFormLoading(true);
  };

  // A custom hook to save form data
  const result = useFormatApiRequest(
    () => adminAddBuildingsApi(payLoadFormData),
    loadApi,
    () => {
      setLoadApi(false);
    },
    () => {
      processFormApi();
    }
  );

  // Process Api
  const processFormApi = async () => {
    if (result.httpState === "SUCCESS") {
      setFormLoading(false);
      alert("Your Building have being Added");
      navigate("/admin/Buildings");
      // Handle Success Here
    } else if (result.httpState === "ERROR") {
      setFormLoading(false);
      alert(
        result.data?.response?.data?.errors[0] ||
          result.data?.response?.data?.message ||
          result.errorMsg
      );
      //Handle Error Here
    }
  };

  return (
    <div className="w3-col w3-container">
      <div className="w3-content">
        <form className="adminForm" onSubmit={handleSubmit}>
          {/* Form Header */}
          <div className="w3-col w3-margin-bottom">
            <h3 className="AdminFormInputHeader myfont1"> Add Building </h3>
            <p className="adminFormHint myfont1">
              Fill in the building details below. Tenants will see this
              information when choosing where to stay.
            </p>
          </div>

          {/* Forms Here */}
          <div className="w3-col">
            {/* Title */}
            <div className="w3-col w3-margin-bottom">
              <div className="w3-col l12 s12 m12">
                <span className="w3-text-white w3-small  myfont1">Title</span>
              </div>
              <div className="w3-col l12 s12 m12">
                <input
                  required
                  name="title"
                  value={payLoad?.title || ""}
                  onChange={handleInputChange}
                  className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                  placeholder="Title"
                />
              </div>
            </div>

            {/* Building Description  */}
            <div className="w3-col w3-margin-bottom">
              <div className="w3-col l12 s12 m12">
                <span className="w3-text-white w3-small  myfont1">
                  Building Description
                </span>
              </div>
              <div className="w3-col l12 s12 m12">
                <textarea
                  required
                  name="description"
                  value={payLoad?.description || ""}
                  onChange={handleInputChange}
                  className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                  placeholder="Description Of Building"
                />
              </div>
            </div>

            {/* Number Of Apartments  */}
            <div className="w3-col w3-margin-bottom">
              <div className="w3-col l12 s12 m12">
                <span className="w3-text-white w3-small  myfont1">
                  Number of Apartments
                </span>
              </div>
              <div className="w3-col l12 s12 m12">
                <input
                  required
                  name="noOfApartments"
                  value={payLoad?.noOfApartments || ""}
                  onChange={handleInputChange}
                  type={"number"}
                  className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                  placeholder="Number of Apartment"
                />
              </div>
            </div>

            <div className="w3-col adminFormRow">
              {/* Rent Price */}
              <div className="w3-col w3-margin-bottom">
                <div className="w3-col l12 s12 m12">
                  <span className="w3-text-white w3-small  myfont1">Price</span>
                </div>
                <div className="w3-col l12 s12 m12">
                  <input
                    required
                    name="price"
                    value={payLoad?.price || ""}
                    type={"number"}
                    onChange={handleInputChange}
                    className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                    placeholder="Amount of Rent"
                  />
                </div>
              </div>

              {/* Service Charge */}
              <div className="w3-col w3-margin-bottom">
                <div className="w3-col l12 s12 m12">
                  <span className="w3-text-white w3-small myfont1">
                    Service Charge
                  </span>
                </div>
                <div className="w3-col l12 s12 m12">
                  <input
                    required
                    name="serviceCharge"
                    value={payLoad?.serviceCharge || ""}
                    type={"number"}
                    onChange={handleInputChange}
                    className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                    placeholder="Amount of Service Charge"
                  />
                </div>
              </div>
            </div>

            {/* Secondary Occupant Price */}
            <div className="w3-col w3-margin-bottom">
              <div className="w3-col l12 s12 m12">
                <span className="w3-text-white w3-small myfont1">
                  Secondary Occupant Price (optional)
                </span>
              </div>
              <div className="w3-col l12 s12 m12">
                <input
                  name="secondaryPrice"
                  value={payLoad?.secondaryPrice ?? ""}
                  type={"number"}
                  min={0}
                  onChange={handleInputChange}
                  className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                  placeholder="Extra rent when a second person shares an apartment"
                />
                <p className="adminFormHint myfont1">
                  Applied to every apartment in this building. Leave empty or 0
                  if apartments can't be shared.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="w3-col w3-margin-bottom">
              <div className="w3-col l12 s12 m12">
                <span className="w3-text-white w3-small  myfont1">Image</span>
              </div>
              <div className="w3-col l12 s12 m12">
                <input
                  required
                  name="image"
                  accept="image/*"
                  type="file"
                  onChange={handleInputChange}
                  className="w3-input w3-border w3-col w3-text-white w3-round-large AdminFormInput"
                  placeholder="Select A file"
                />
                {imagePreview && (
                  <img
                    className="adminFormImagePreview"
                    src={imagePreview}
                    alt="Selected building"
                  />
                )}
              </div>
            </div>
          </div>

          {/* Button Here */}
          <div className="w3-col w3-margin-bottom">
            <button
              className="w3-btn w3-round-large regButton w3-col"
              disabled={formLoading}
            >
              {!formLoading ? (
                "Add Building"
              ) : (
                <LoadingOutlined rev={undefined} />
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminAddBuilding;
